import React, { useEffect, useState, useRef, lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEWS = [{
  src: 'https://cdn.magicpatterns.com/uploads/sjNkrbFjDuZuuJhSyNJRVy/PAGINA_3.png',
  tomo: 'TOMO 1',
  title: '¿Qué es Reiki realmente?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i2toEWePsVJJFCifHhUN8f/PAGINA_4.png',
  tomo: 'TOMO 1',
  title: 'Historia moderna del Reiki'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5suhChWnjo6rVyzCtARXsX/PAGINA_4.png',
  tomo: 'TOMO 2',
  title: 'Chakra Raíz · Seguridad y estabilidad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4mY6e22nmHDibZxEhc9sq2/PAGINA_5.png',
  tomo: 'TOMO 2',
  title: 'Chakra Sacro · Emociones y creatividad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/etuR5vz9vvzfQzq2vRp3jy/PAGINA_2.png',
  tomo: 'TOMO 3',
  title: 'El rol del terapeuta Reiki'
}];
export function CoursePreviewSection() {
  const [ref1, vis1] = useReveal();
  const [active, setActive] = useState<number | null>(null);
  const [current, setCurrent] = useState(0);
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollToIndex = (idx: number) => {
    if (!trackRef.current) return;
    const track = trackRef.current;
    const item = track.children[idx] as HTMLElement | undefined;
    if (item) {
      track.scrollTo({
        left: item.offsetLeft - (track.offsetWidth - item.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }
  };
  const handleScroll = () => {
    if (!trackRef.current) return;
    const track = trackRef.current;
    const center = track.scrollLeft + track.offsetWidth / 2;
    let closest = 0;
    let closestDist = Infinity;
    Array.from(track.children).forEach((child, idx) => {
      const el = child as HTMLElement;
      const elCenter = el.offsetLeft + el.offsetWidth / 2;
      const dist = Math.abs(center - elCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closest = idx;
      }
    });
    setCurrent(closest);
  };
  const next = () => {
    const nextIdx = Math.min(current + 1, PREVIEWS.length - 1);
    scrollToIndex(nextIdx);
  };
  const prev = () => {
    const prevIdx = Math.max(current - 1, 0);
    scrollToIndex(prevIdx);
  };
  useEffect(() => {
    scrollToIndex(0);
  }, []);
  return <section className="bg-[#1A1625] py-20 md:py-32 px-0 sm:px-6 border-t border-[#342D45] overflow-hidden" data-id="element-114">
      <div className="container mx-auto max-w-6xl" data-id="element-115">
        <div ref={ref1} className={`reveal text-center mb-16 px-5 ${vis1 ? 'is-visible' : ''}`} data-id="element-116">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-117">
            Así se ve realmente el material que vas a recibir.
          </h2>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-118">
          {/* Prev / Next buttons (desktop) */}
          <button onClick={prev} aria-label="Anterior" disabled={current === 0} className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-20 w-14 h-14 rounded-full bg-white/10 backdrop-blur-md shadow-xl border border-white/20 items-center justify-center text-white hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all disabled:opacity-0" data-id="element-119">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-120">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" data-id="element-121" />
            </svg>
          </button>
          <button onClick={next} aria-label="Siguiente" disabled={current === PREVIEWS.length - 1} className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-20 w-14 h-14 rounded-full bg-white/10 backdrop-blur-md shadow-xl border border-white/20 items-center justify-center text-white hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all disabled:opacity-0" data-id="element-122">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-123">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" data-id="element-124" />
            </svg>
          </button>

          {/* Track */}
          <div ref={trackRef} onScroll={handleScroll} className="flex gap-6 md:gap-10 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-8 px-[15%] sm:px-[20%] md:px-[25%]" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-125">
            {PREVIEWS.map((p, idx) => <button key={idx} onClick={() => {
            if (idx === current) {
              setActive(idx);
            } else {
              scrollToIndex(idx);
            }
          }} className={`group relative flex-none w-[75%] sm:w-[60%] md:w-[45%] lg:w-[35%] snap-center bg-white rounded-2xl overflow-hidden shadow-2xl transition-all duration-500 text-left ${current === idx ? 'scale-100 opacity-100' : 'scale-90 opacity-40'}`} data-id="element-126">
                <div className="aspect-[3/4] overflow-hidden bg-[#F9F8F6]" data-id="element-127">
                  <img src={p.src} alt={`${p.tomo} — ${p.title}`} className="w-full h-full object-cover" loading="lazy" data-id="element-128" />
                </div>
              </button>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-3 mt-4" data-id="element-129">
            {PREVIEWS.map((_, idx) => <button key={idx} onClick={() => scrollToIndex(idx)} aria-label={`Ir a página ${idx + 1}`} className={`h-2 rounded-full transition-all ${current === idx ? 'bg-[#D4AF37] w-10' : 'bg-white/20 w-2 hover:bg-white/40'}`} data-id="element-130" />)}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && <div onClick={() => setActive(null)} className="fixed inset-0 z-[100] bg-[#1A1625]/95 backdrop-blur-md flex items-center justify-center p-4" data-id="element-131">
          <button onClick={() => setActive(null)} aria-label="Cerrar" className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" data-id="element-132">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-133">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-134" />
            </svg>
          </button>
          <img src={PREVIEWS[active].src} alt={PREVIEWS[active].title} onClick={e => e.stopPropagation()} className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" data-id="element-135" />
        </div>}

      <style data-id="element-136">{`
        .reveal > .relative > div::-webkit-scrollbar { display: none; }
      `}</style>
    </section>;
}